import useUserStore from "@store/useUserStore";
import useSystemStore from "@store/useSystemStore";
import { useDebounce } from "@hooks/useDebounce";
import { useEmailInitialization } from "./hooks/useEmailInitialization";
import { ActiveScreen } from "@enums/screens.enum";
import ConnectionScreen from "@screens/connect-meridian";
import ConnectionIssueScreen from "@screens/connection-issue";
import SyncEmailScreen from "@screens/sync-email";
import SyncDisabledScreen from "@screens/sync-email/SyncDisabledScreen";
import ThreadScreen from "@screens/thread";
import { TransitionWrapper } from "@ui/Transition";
import { AppLoader } from "@ui/Loaders";

export function EmailScreenManager() {
  const { hasSession } = useUserStore();

  useEmailInitialization(hasSession);

  const { isAppLoading, isAppOffline, activeScreen } = useSystemStore();
  const debouncedIsOffline = useDebounce(isAppOffline, 500);

  if (debouncedIsOffline) return <ConnectionIssueScreen isVisible={isAppOffline} />;

  if (isAppLoading) return <AppLoader />;

  const getScreen = () => {
    switch (activeScreen) {
      case ActiveScreen.LOADING:
        return <AppLoader />;
      case ActiveScreen.CONNECT:
        return <ConnectionScreen />;
      case ActiveScreen.SYNC_DISABLED:
        return <SyncDisabledScreen />;
      case ActiveScreen.SYNC_EMAIL:
        return <SyncEmailScreen />;
      case ActiveScreen.THREAD:
        return <ThreadScreen />;
      default:
        return <AppLoader />;
    }
  };

  return <TransitionWrapper screenKey={activeScreen}>{getScreen()}</TransitionWrapper>;
}
